import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BaseComponent } from '../../../../../shared/base-components/base.component';
import { SelectListItemModel } from '../../../../../shared/models/select-list-item.model';
import { AZMVDNowClaimAccountDenialReasonType } from '../../../../models/enums/azmvdnow-claim-account-denial-reason-type.enum';
import { MvdNowClaimAccountModalService } from '../../../services/mvdnow-claim-account-modal.service';
import { MvdnowClaimAccountModalContextModel } from '../../models/mvdnow-claim-account-modal-context.model';

@Component({
    selector: 'mvdnow-claim-account-modal',
    templateUrl: './mvdnow-claim-account-modal.component.html',
    styles: [
    ]
})
export class MvdnowClaimAccountModalComponent extends BaseComponent implements OnInit, OnDestroy {
    public showRestrict = false;
    public form: FormGroup;
    public inProgress: boolean;
    public denialReasons: SelectListItemModel[];
    public denialReasonEnum: AZMVDNowClaimAccountDenialReasonType = new AZMVDNowClaimAccountDenialReasonType();

    private subscriptions: Subscription[] = [];
    constructor(private router: Router,
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: MvdnowClaimAccountModalContextModel,
        public dialogRef: MatDialogRef<MvdnowClaimAccountModalComponent>,
        private claimAccountModalService: MvdNowClaimAccountModalService,
        private fb: FormBuilder
    ) {
        super();
    }

    ngOnInit(): void {
        this.buildform();

        this.claimAccountModalService.getClaimAccountDenialReasons().subscribe({
            next: (denialReasons) => {
                this.denialReasons = denialReasons;
            },
            error: (error) => {
                this.handleValidationResult(error);
            }
        });
    }

    ngOnDestroy() {
        for (let sub of this.subscriptions) {
            sub.unsubscribe();
        }
    }

    private buildform() {
        this.form = this.fb.group({
            'customerNumberId': [this.data.customerNumberId],
            'denialReasonTypeId': [null, Validators.required],
            'denialReasonDescription': [null]
        });

        this.subscriptions.push(
            this.form.get('denialReasonTypeId').valueChanges.subscribe((value) => {
                const description = this.form.get('denialReasonDescription');
                if (value == this.denialReasonEnum.Other.id) {
                    description.addValidators(Validators.required);
                } else {
                    description.clearValidators();
                }
                description.updateValueAndValidity();
            })
        );
    }

    goToClaimAccount(): void {
        const url = this.router.serializeUrl(
            this.router.createUrlTree([`customer/mvdnowclaimaccount/${this.data.customerNumberId}`])
        );

        window.open(url, '_blank');
        this.dialogRef.close();
    }

    submit() {
        if (this.form.valid) {
            this.inProgress = true;

            this.subscriptions.push(this.claimAccountModalService.submitClaimAccountDenial(this.form.value).subscribe({
                next: () => {
                    this.dialogRef.close();
                },
                error: (error) => {
                    this.inProgress = false;
                    this.handleValidationResult(error);
                }
            }));
        }
    }

    beginRestrict(): void {
        this.showRestrict = true;
    }

    back() {
        this.showRestrict = false;
    }
}
